export const UNIMED_CEARA = (process.env.NODE_ENV === 'production')
  ? 1128
  : 1119

export const CLINICA_TESTE = (process.env.NODE_ENV === 'production')
  ? 1049
  : 1124
